<template>
  <section class="section section--elevated">
    <div class="container">
      <h2 class="section-title">模型训练全流程支持</h2>
      <p class="section-lead">全架构服务器产品矩阵，承接多样化硬件定制需求</p>
      <div class="benefits-list">
        <article v-for="(s, i) in steps" :key="s.title" class="benefit-card">
          <span class="benefit-watermark" aria-hidden="true">{{ i + 1 }}</span>
          <div class="benefit-content">
            <h3>{{ s.title }}</h3>
            <p>{{ s.desc }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const steps = [
  { title: '数据准备', desc: '高速分布式存储，支持 PB 级数据加载，内置数据清洗与标注工具。' },
  { title: '模型开发', desc: 'JupyterLab 交互式环境，预置主流模型库，支持代码版本管理。' },
  { title: '分布式训练', desc: '一键启动千卡级分布式训练，自动检查点保存，断点续训。' },
  { title: '模型评估', desc: '自动化评测流水线，支持多维度指标对比，A/B 测试与模型选型。' },
  { title: '推理部署', desc: '模型一键导出与部署，支持批处理推理与在线服务，自动扩缩容。' }
];
</script>
<style scoped lang="scss"> 
  .benefit-content {
    padding: 24px 0;
  }
</style>  